import styled, { css } from "styled-components";

import { IThemeProps } from "@/styles";
import { fadeIn } from "@/styles/Mixins";

export const Main = styled.main`
  background: ${(props: IThemeProps) => props.theme.colors.thumbsBackground};
`;

export const ThumbWrapper = styled.div<{ mobile?: boolean }>`
  position: relative;
  margin-right: ${(props: any) => props.theme.spacing.desktop.s300 / 2}px;
  width: 50%;
  max-width: 322px;
  margin-bottom: ${(props: any) => props.theme.spacing.desktop.s500}px;
  z-index: ${(props: any) => props.theme.zIndex.h300};

  &:last-child {
    margin-right: 0;
    margin-left: ${(props: any) => props.theme.spacing.desktop.s300 / 2}px;
  }
`;

const ExtendedThumbsHeaderBackground = css`
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 45px;
    background: ${(props: IThemeProps) =>
      props.theme.colors.thumbsHeaderBackground};
  }
`;

export const ThumbsWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0 15px;
  ${(props: IThemeProps) =>
    props.theme.thesis.hasExtendedThumbsHeader &&
    ExtendedThumbsHeaderBackground}

  ${(props: IThemeProps) =>
    props.theme.thesis.hasExtraThumbsPadding && `padding-top: 15px;`}
`;

export const Placeholder = styled.div`
  display: flex;
  justify-content: center;
  height: 34px;
  margin-top: 10px;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    height: 26px;
  }
`;
export const HiddenCount = styled.div`
  font-size: ${(props: IThemeProps) => props.theme.typography.h800};
  font-weight: 600;
  color: ${(props: IThemeProps) => props.theme.colors.thumbsCountHidden};
  animation: ${fadeIn} 0.2s ease-in;
  animation-fill-mode: forwards;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    font-size: ${(props: IThemeProps) => props.theme.typography.h600};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props: IThemeProps) =>
    props.theme.colors.thumbsHeaderBackground};

  min-height: 110px;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    min-height: 60px;
  }
`;

export const Title = styled.h1`
  max-width: ${(props: IThemeProps) => props.theme.globals.maxInteractionWidth};
  padding: 15px 30px;
  font-family: ${(props: IThemeProps) => props.theme.globals.fontFamilyExtra};
  font-size: ${(props: IThemeProps) => props.theme.typography.h710};
  font-weight: ${(props: IThemeProps) => props.theme.globals.fontWeightBold};
  line-height: 1.3;
  text-align: center;
  color: ${(props: IThemeProps) => props.theme.colors.thumbsHeaderFont};

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    font-size: ${(props: IThemeProps) => props.theme.typography.h320};
  }
`;
